import { Component, Output, Input, EventEmitter } from "@angular/core";

@Component({
  selector: "upsell-guarantee",
  templateUrl: "upsell-guarantee.html",
  styleUrls: ["upsell-guarantee.scss"]
})

export class UpsellGuaranteeComponent {

  @Input() buttonYesText: string = '';
  @Input() buttonNoText: string = '';
  @Input() upsellGuarantee_text: string = 
    `
      <p class='text-3xl desktop:text-4xl cooper my-7'>90-Day Money-Back Guarantee</p> 
      <p class='mb-4'>If you aren’t completely satisfied with your purchase for any reason, no sweat.</p>
      <p class=''>Our customer service team will be happy to help you return your order for a full refund of your purchase price, minus the cost of shipping. (Even if you send back empty bags.)</p>
    `
  @Input() showbuttonYesText: boolean = true;
  @Input() showbuttonNoText: boolean = true;
  @Input() description: string = '';
  @Input() showDescription: boolean = false;
  @Input() image: string = '';
  @Input() imageAlt: string = '';
  @Input() showImage: boolean = true;
  @Input() upsellCtaTextButtonsClass: string;
  
  @Input() upsellGuarantee_mbgImg: string = 'https://cdn.hartfelt.com/images/mbg_badge.svg';


  //Provide external method to navigate to next page over funnel
  @Output() eventEmitter: EventEmitter<boolean> = new EventEmitter();

  buttonValue: boolean = false;

  constructor() {}

  nextPage(buttonValue: boolean) {
    this.buttonValue = buttonValue ? true : false;
    this.eventEmitter.emit(this.buttonValue);
  }
}
